import { useEffect } from "react";

/**
 * Static Open-Graph preview page — rendered at /_og
 * We capture this route to /og-image.jpg for social share cards (X/LinkedIn).
 * Meant to be viewed at exactly 1200×630.
 */
export default function OgImagePage() {
  useEffect(() => {
    document.body.style.margin = "0";
    document.body.style.background = "#0A0A0A";
  }, []);

  return (
    <div
      style={{
        width: 1200,
        height: 630,
        background:
          "linear-gradient(135deg, #0A0A0A 0%, #0F1C3A 55%, #0052FF 100%)",
        color: "#FFFFFF",
        fontFamily: "'Outfit', 'IBM Plex Sans', system-ui, sans-serif",
        padding: "72px 80px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        boxSizing: "border-box",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* subtle grid */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "linear-gradient(to right, rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.05) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
          pointerEvents: "none",
        }}
      />

      {/* top row: logo */}
      <div style={{ display: "flex", alignItems: "center", gap: 18, position: "relative" }}>
        <div
          style={{
            width: 68,
            height: 68,
            background: "#0052FF",
            display: "grid",
            placeItems: "center",
            fontSize: 42,
            fontWeight: 800,
            letterSpacing: "-2px",
          }}
        >
          H
        </div>
        <div style={{ lineHeight: 1 }}>
          <div style={{ fontSize: 34, fontWeight: 800, letterSpacing: "-1px" }}>HCS Computers AI</div>
          <div style={{ fontSize: 14, opacity: 0.75, marginTop: 8, textTransform: "uppercase", letterSpacing: "3px", fontFamily: "IBM Plex Mono, monospace" }}>
            IT Training & Consultancy
          </div>
        </div>
      </div>

      {/* headline */}
      <div style={{ position: "relative" }}>
        <div style={{ fontSize: 22, opacity: 0.75, letterSpacing: "3px", textTransform: "uppercase", marginBottom: 20, fontFamily: "IBM Plex Mono, monospace" }}>
          20+ years · Salesforce · AWS · MuleSoft · IBM · AI
        </div>
        <h1
          style={{
            fontSize: 76,
            fontWeight: 800,
            lineHeight: 1.0,
            letterSpacing: "-2.5px",
            margin: 0,
            maxWidth: 1040,
          }}
        >
          Train in the tech that
          <br />
          <span style={{ color: "#FACC15" }}>actually hires</span> in 2026.
        </h1>
      </div>

      {/* footer row */}
      <div
        style={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderTop: "1px solid rgba(255,255,255,0.15)",
          paddingTop: 24,
        }}
      >
        <div style={{ display: "flex", gap: 32, fontSize: 18 }}>
          <div>
            <div style={{ fontSize: 12, opacity: 0.6, letterSpacing: "2px", textTransform: "uppercase", fontFamily: "IBM Plex Mono, monospace" }}>Book a demo</div>
            <div style={{ fontWeight: 700, marginTop: 4 }}>₹500 (India) · $15 (International)</div>
          </div>
          <div>
            <div style={{ fontSize: 12, opacity: 0.6, letterSpacing: "2px", textTransform: "uppercase", fontFamily: "IBM Plex Mono, monospace" }}>Website</div>
            <div style={{ fontWeight: 700, marginTop: 4 }}>hcs-computers-ai.com</div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 10, fontSize: 12, fontFamily: "IBM Plex Mono, monospace", opacity: 0.75 }}>
          <span style={{ border: "1px solid rgba(255,255,255,0.4)", padding: "6px 10px" }}>PMP</span>
          <span style={{ border: "1px solid rgba(255,255,255,0.4)", padding: "6px 10px" }}>ITIL</span>
          <span style={{ border: "1px solid rgba(255,255,255,0.4)", padding: "6px 10px" }}>SALESFORCE</span>
          <span style={{ border: "1px solid rgba(255,255,255,0.4)", padding: "6px 10px" }}>AWS</span>
        </div>
      </div>
    </div>
  );
}
